import React, { Component } from 'react';
import { connect } from 'react-redux';
import { history } from '../../../../store';
import IgniteDataTable from '../../../common/datatable';
import { GROUP_ABM, GROUP_RBM, GROUP_RDR, GROUP_SUPER } from '../../../../data/userGroups';
import { doPseudoLogin } from '../../../../actions/users';

class UsersList extends Component {
  isRep = userGroup => !![GROUP_ABM, GROUP_RBM, GROUP_RDR].find(group => group === userGroup.toLowerCase());

  isSuperAdmin = userGroup => GROUP_SUPER === userGroup.replace(' ', '_').toLowerCase();

  onPseudoLogin = (user) => {
    const userGroupName = user.attributes['user-group-name'];
    const { currentUser, dispatch } = this.props;
    const redirectUrl = this.isRep(userGroupName) ? '/team' : '/';
    const isSuperAdmin = this.isSuperAdmin(userGroupName);
    const isYourself = user.attributes.email === currentUser.attributes.email;

    if (isSuperAdmin || isYourself) {
      return false;
    }

    dispatch(doPseudoLogin(user.id))
      .then(() => {
        setTimeout(() => {
          localStorage.setItem('admin-pseudo-login-started-from', window.location.href);
          window.location.href = redirectUrl;
        }, 2000);
      });

    return true;
  };

  render() {
    const columns = [
      {
        prop: 'name',
        title: 'Name'
      },
      {
        prop: 'username',
        title: 'Username'
      },
      {
        prop: 'user-group-name',
        title: 'Usergroup'
      },
      {
        prop: 'status',
        title: 'Status'
      },
    ];

    const actions = [
      {
        label: 'Edit',
        permissions: {
          action: 'update',
          subjectClass: 'User'
        },
        render: (cell, row) => row.attributes.links && row.attributes.links.edit,
        callback: (row) => {
          const type = row.attributes.links.edit.indexOf('manage_owners') > 0 ? 'details' : 'edit';

          history.push(`/admin/users/${row.id}/${type}`);
        }
      },
      {
        label: 'Pseudo Log in',
        permissions: {
          action: 'rep-pseudo-login-read,rep-pseudo-login-write,pseudo-login-read,pseudo-login-write',
          subjectClass: 'web_app',
          mode: 'hide'
        },
        render: (cell, row) => !this.isSuperAdmin(row.attributes['user-group-name']),
        callback: (row) => {
          this.onPseudoLogin(row);
        }
      },
      {
        label: 'Add points',
        permissions: {
          action: 'create',
          subjectClass: 'PointTransaction'
        },
        render: (cell, row) => row.attributes['user-group-name'] === 'Owner' && row.attributes.status !== 'disabled',
        callback: (row) => {
          history.push(`/admin/manual-points-transactions/${row.id}`);
        }
      }
    ];

    const { users, paging } = this.props;

    return (
      <div>
        <IgniteDataTable
          actions={actions}
          columns={columns}
          data={users}
          hideId={false}
          actionWidth="380"
          dataSize={paging ? paging.number * paging.size : users.length}
          pagination={{
          page: this.props.currentPage,
          sizePerPage: 20,
          onPageChange: this.props.onPageChange,
        }}
          remote
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.viewConfig.profile,
});

export default connect(mapStateToProps)(UsersList);



// WEBPACK FOOTER //
// ./src/components/admin/users/list/users-list.jsx